var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.25C3.49594 0.25 0.25 3.49594 0.25 7.5C0.25 11.5041 3.49594 14.75 7.5 14.75C9.23189 14.75 10.8219 14.1427 12.0689 13.1295L17.4801 18.5407C17.773 18.8336 18.2478 18.8336 18.5407 18.5407C18.8336 18.2478 18.8336 17.773 18.5407 17.4801L13.1295 12.0689C14.1427 10.8219 14.75 9.23189 14.75 7.5C14.75 3.49594 11.5041 0.25 7.5 0.25ZM1.75 7.5C1.75 4.32436 4.32436 1.75 7.5 1.75C10.6756 1.75 13.25 4.32436 13.25 7.5C13.25 10.6756 10.6756 13.25 7.5 13.25C4.32436 13.25 1.75 10.6756 1.75 7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.73e2af2bc05a4e0a1655010055b2dbc7.svg";
export { ForwardRef as ReactComponent };